export const formatDateYyyyMmDd = (value?: string | Date | null) => {
  if (!value) return '';

  if (typeof value === 'string') {
    // Accept ISO-like formats and already-formatted YYYY-MM-DD strings
    if (value.length >= 10) return value.slice(0, 10);
    return value;
  }

  const time = value.getTime();
  if (Number.isNaN(time)) return '';

  return value.toISOString().slice(0, 10);
};
